/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIDatasetReference,
    AIDatasetReferenceFromJSON,
    AIDatasetReferenceFromJSONTyped,
    AIDatasetReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIModelUpdate
 */
export interface AIModelUpdate {
    /**
     * 
     * @type {AIDatasetReference}
     * @memberof AIModelUpdate
     */
    dataset: AIDatasetReference;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AIModelUpdate
     */
    parameters: { [key: string]: string | undefined; };
    /**
     * 
     * @type {string}
     * @memberof AIModelUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AIModelUpdate
     */
    trainingTaskId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AIModelUpdate
     */
    threshold?: number;
    /**
     * 
     * @type {number}
     * @memberof AIModelUpdate
     */
    epoch?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AIModelUpdate
     */
    preprocessingTask?: string | null;
}

export function AIModelUpdateFromJSON(json: any): AIModelUpdate {
    return AIModelUpdateFromJSONTyped(json, false);
}

export function AIModelUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModelUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataset': AIDatasetReferenceFromJSON(json['dataset']),
        'parameters': json['parameters'],
        'name': json['name'],
        'trainingTaskId': !exists(json, 'training_task_id') ? undefined : json['training_task_id'],
        'threshold': !exists(json, 'threshold') ? undefined : json['threshold'],
        'epoch': !exists(json, 'epoch') ? undefined : json['epoch'],
        'preprocessingTask': !exists(json, 'preprocessing_task') ? undefined : json['preprocessing_task'],
    };
}

export function AIModelUpdateToJSON(value?: AIModelUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dataset': AIDatasetReferenceToJSON(value.dataset),
        'parameters': value.parameters,
        'name': value.name,
        'training_task_id': value.trainingTaskId,
        'threshold': value.threshold,
        'epoch': value.epoch,
        'preprocessing_task': value.preprocessingTask,
    };
}


